import { eventsAuthenticatedAxios } from '@/api/axios'
import { useHostNameStore } from '@/stores/useHostNameStore'
import type { UpdateNatureFamilityRequestDto, User, UserDto } from '@/types'
import axios from 'axios'

export async function getUserById(id: string, email: string) {
   const hostNameStore = useHostNameStore()
    
    const { data } = await eventsAuthenticatedAxios.get<UserDto>(
        `users/${id}/state/${hostNameStore.hostname}?email=${email}`
    )
    return data
}

export async function addNewUser(userId: string) {
    await axios.post(`${import.meta.env.VITE_CONTENT_API}/users`, {
        adB2cId: userId
    })
}
export async function updateNatureFamily(
    information: UpdateNatureFamilityRequestDto
) {
    const { data } = await axios.put<User>(
        `${import.meta.env.VITE_CONTENT_API}/users/${
            information.id
        }/naturefamily/`,
        information,
        {
            headers: { 'Content-Type': 'application/json' }
        }
    )
    return data
}

export async function deleteUser(id: string) {
    const { data } = await axios.delete(
        `${import.meta.env.VITE_CONTENT_API}/users/${id}`
    )
    return data
}

export async function updateUserAsync(user: User) {
    const { data } = await axios.put(
        `${import.meta.env.VITE_CONTENT_API}/users`,
        user
    )
    return data
}
